export default "__VITE_ASSET__B_mvs9qq__"